import { createContext } from "react";

export interface CallListGlobalModalContextValue {
  consultantId: string | null;
  open: (consultantId: string) => void;
}

export const CallListGlobalModalContext = createContext<CallListGlobalModalContextValue>({
  consultantId: null,
  open: () => {}
});
